import { NetworkStatus } from '@apollo/client';
import { useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { fetchRoutingUsersQuery } from '../queries/user-rpc.queries';
export const useRoutableUsers = ({
  includeBots,
  objectTypeId,
  routingSource,
  specificUsers,
  workspaceId
}) => {
  const {
    data,
    error,
    loading,
    networkStatus,
    refetch
  } = useQuery(fetchRoutingUsersQuery, {
    notifyOnNetworkStatusChange: true,
    onError: errorToTrack => {
      Raven.captureException(errorToTrack);
    },
    skip: !workspaceId && !objectTypeId,
    variables: {
      includeBots,
      objectTypeId,
      routingSource,
      specificUsers,
      workspaceId
    }
  });
  const refetchUsers = useCallback(() => refetch({
    includeBots,
    objectTypeId,
    routingSource,
    specificUsers,
    workspaceId
  }), [includeBots, objectTypeId, refetch, routingSource, specificUsers, workspaceId]);
  return {
    error,
    loading,
    refetch: refetchUsers,
    refetching: networkStatus === NetworkStatus.refetch,
    users: data === null || data === void 0 ? void 0 : data.routingUsers
  };
};